import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, TextV2, styled } from '@withjoy/joykit';

export const StyledTitle = styled(TextV2)`
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const StyledContainer = styled(Box)``;

const containerStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

const titleStyles: StyleSystemProps = {
  maxWidth: {
    _: '294px',
    sm2: '675px',
  },
  display: 'flex',
  flexDirection: 'column',
  margin: '0px 48px 40px 48px',
  textAlign: 'center',
};

export const styles = {
  container: containerStyles,
  title: titleStyles,
};
